import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '@/modules/admin-access-codes/styles.less';

const statusConfig = {
  active: {
    background: '#EDF7FE',
    border: '1px solid #D0EAFF',
    color: '#006FC5',
    label: 'Assigned',
  },
  redeemed: {
    background:
      ' linear-gradient(0deg, rgba(51, 143, 108, 0.08), rgba(51, 143, 108, 0.08))',
    border: '1px solid #D8ECE3',
    color: '#277D5C',
    label: 'Redeemed',
  },
  disabled: {
    background: '#EEEEEE',
    border: '1px solid #D8D8D8',
    color: '#616161',
    label: 'Disabled',
  },
};

const StatusCell = ({ value }) => {
  const { t } = useTranslation();
  const config = statusConfig[value] || {
    background: '#EDF7FE',
    border: '1px solid #D0EAFF',
    color: '#006FC5',
    label: value,
  };

  return (
    <span
      className={styles.status}
      style={{
        background: config.background,
        border: config.border,
        color: config.color,
      }}
    >
      {t(config.label)}
    </span>
  );
};

export const renderStatusCell = ({ value }) => <StatusCell value={value} />;
